import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import ('./scss/main.scss')
import mixins from './mixins/index'
import axios from 'axios'
import VueAxios from 'vue-axios'
import CKEditor from 'ckeditor4-vue'
import i18n from './plugins/i18n'
require('./plugins')

Vue.use(VueAxios, axios);
Vue.mixin(mixins);
Vue.use(CKEditor);

Vue.config.productionTip = process.env.VUE_APP_PROD

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
